import React, { useEffect } from 'react';
import { AmbHeroSection } from '../../components/sections/AmbHeroSection';
import { MapSubmissionSection } from '../../components/sections/MapSubmissionSection';
import { HowItWorksSection } from '../../components/sections/HowItWorksSection';
import { ValueSection } from '../../components/sections/ValueSection';
import { TrustSection } from '../../components/sections/TrustSection';
import { StickyMobileCta } from '../../components/ui/StickyMobileCta';
import { siteConfig } from '../../config/site';
import {
  trackFunnelStep,
  FunnelSteps,
  initScrollDepthTracking,
  initSectionViewTracking,
} from '../../lib/analytics';

const SECTION_VIEWS = [
  { id: siteConfig.anchors.howItWorks, event: FunnelSteps.HOW_IT_WORKS_VIEWED },
  { id: siteConfig.anchors.map, event: FunnelSteps.MAP_SECTION_VIEWED },
];

const Landing = () => {
  useEffect(() => {
    trackFunnelStep(FunnelSteps.LANDING_VIEW);
    const stopScroll = initScrollDepthTracking();
    const stopSections = initSectionViewTracking(SECTION_VIEWS);
    return () => {
      stopScroll();
      stopSections();
    };
  }, []);

  return (
    <div className="min-h-screen pb-20 md:pb-0">
      <AmbHeroSection />
      <HowItWorksSection />
      <MapSubmissionSection />
      <ValueSection />
      <TrustSection />
      <StickyMobileCta />
    </div>
  );
};

export default Landing;
